export const roles = [
  {
    text: 'Admin',
    value: 'admin',
    description: 'Admin can create, read, update and delete all data',
    sendRoles: ['admin', 'importer', 'importer-accounts', 'manufacturer', 'catch-verifier'],
    receiveRoles: [],
  },
  {
    text: 'Catch Verifier',
    value: 'catch-verifier',
    description: 'This user can verify catches and ensure data accuracy.',
    sendRoles: ['catch-verifier'],
    receiveRoles: ['admin'],
  },
  {
    text: 'Colleague with same permissions as you',
    value: 'importer',
    description: 'This user has the same permissions as yourself and can invite other users.',
    sendRoles: ['importer', 'importer-accounts', 'manufacturer'],
    receiveRoles: [],
  },
  {
    text: 'Accountant',
    value: 'importer-accounts',
    description:
      'This user can view and manage orders and credits but cannot access product or attestation data.',
    sendRoles: [],
    receiveRoles: ['importer-accounts', 'importer'],
  },
  {
    text: 'Manufacturer',
    value: 'manufacturer',
    description:
      'This user can create, read and update product and attestation data but cannot spend credits or manage users.',
    sendRoles: ['manufacturer'],
    receiveRoles: ['manufacturer'],
    displayBySenderRole: {
      importer: {
        text: 'Manufacturer',
        description:
          'Invite a manufacturer to manage products and attestations for your importer account.',
      },
      manufacturer: {
        text: 'Colleague at your manufacturer',
        description:
          'Invite another user from your manufacturer to help manage products and attestations.',
      },
      admin: {
        text: 'Manufacturer',
        description: 'Invite a manufacturer user who can manage product and attestation data.',
      },
    },
  },
]
